var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('select-input',{attrs:{"setup":{
      'func': _vm.setIndexInValueHandler,
      'args': {
        'model': _vm.value,
        'key': 'property_index',
        'options': _vm.compatiblePropertiesOptions,
        'clearable': false,
        'taggable': true,
        'prefix': ((_vm.snakeCase(_vm.ActionTypes.Property)) + "_action_value_"),
        'createButton': {
          'title': _vm.$t('create_property_button').toString(),
          'callback': _vm.prepareNewProperty
        },
        'validation': 'required'
      }
    }}}),_c('create-new-property',{attrs:{"init-name":_vm.newPropertyName,"create-new-property":_vm.createNewProperty,"is-open":_vm.isOpen},on:{"update:isOpen":function($event){_vm.isOpen=$event},"update:is-open":function($event){_vm.isOpen=$event},"setProperty":function (ref) {
        var id = ref.id;

        return _vm.setValuePropIndex(id);
}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }